import styled from '@emotion/styled'
import { theme } from '@hhgtech/hhg-components/misc'

export const StyledCategorySubCategory = styled.div`
  .wrapper {
    background-color: ${theme.colors.white};

    .text {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 20px;

      a {
        color: ${theme.colors.primaryBase};
        font-weight: 700;
        text-decoration: none;
      }
    }

    .category-card {
      width: calc(100% - 6px);
      min-height: 180px;

      .banner {
        min-height: 102px;
        > * {
          max-height: 100%;
        }
      }

      .content {
        margin-top: 10px;
      }
    }
  }

  .ampCategory img {
    object-fit: contain;
  }

  &[data-type-mobile='false'] {
    margin-bottom: 64px;

    .scroll-list {
      .grid-layout {
        width: calc(100% + 32px);
        margin-left: -16px;
      }

      .category-card {
        width: calc(100% - 32px);
      }

      .left-arrow-scroll {
        left: -65px;
        cursor: pointer;
      }

      .right-arrow-scroll {
        right: -65px;
        cursor: pointer;
      }
    }
  }

  &[data-type-mobile='true'] {
    margin-bottom: 50px;

    .wrapper {
      margin-top: 20px;
      margin-bottom: 20px;
    }

    .scroll-list {
      padding: 0 1rem;
      .arrow-right {
        right: -15px;
      }
      .arrow-left {
        left: -15px;
      }
      .bullet-nav {
        bottom: -20px;
      }
    }

    .category-card {
      width: calc(100% - 8px);
      height: 130px;
      min-height: 110px;

      .banner {
        min-height: 63px;
        //width: 65%;
      }

      .content {
        margin-top: 5px;
      }
    }
  }

  &[data-type-mobile='true'][data-layout-type='long'] {
    .category-card {
      display: flex;
      height: auto;
      min-height: 50px;
      flex-direction: row;
      align-items: center;
      padding: 8px 0;

      .banner {
        width: 80px;
        height: 48px;
        min-height: 48px;
        padding: 0 16px;
        flex-shrink: 0;
      }

      .content {
        margin-top: 0;
        text-align: left;
      }
    }
  }
`
